export const isAdmin = (scope) => {
    if (!Array.isArray(scope)) return false;
    return scope.includes('admin:all') || scope.includes('admin:basic');
};
